import React from 'react';
import { FormOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { paths } from '@app/constants';
import { getProcessorOptions } from '@app/pages/b2b/QuestionsLibrary/pages/constants';
import { transformQuestionDependencyParameter } from '@app/utils';
import { Namespace, usePermissions } from '@data/index';
import { DependencyType, QuestionDependencyView } from '@data/sdk/match';
import { Button, AntdSpace, AntdTypography } from '@ui/components';
import { ArrowUpRightIcon } from '@ui/icons';

const { Text } = AntdTypography;

type DependencyFormProps = {
  dependency?: QuestionDependencyView;
  onEditClick: () => void;
  questionText: string;
};

export const HiddenQuestionDependencyPreview = ({
  questionText,
  dependency,
  onEditClick,
}: DependencyFormProps) => {
  const { t } = useTranslation([Namespace.ADMIN]);
  const { IS_REVIEWER } = usePermissions();

  return (
    <AntdSpace direction="vertical" size={2} className="items-center">
      <AntdSpace
        direction="vertical"
        className="p-4 bg-base-100 rounded-default border-base-300 border-solid"
      >
        <AntdSpace direction="vertical" size="middle">
          <div className="flex flex-col">
            <Text className="text-base text-base-600">
              {t('question_page.details.dependencies.processor')}:
            </Text>
            <Text className="text-base">
              {getProcessorOptions().find((el) => el.value === dependency?.type)?.label}
            </Text>
          </div>

          {(dependency?.type === DependencyType.GreaterThan ||
            dependency?.type === DependencyType.EqualTo) && (
            <div className="flex flex-col">
              <Text className="text-base text-base-600">
                {t('question_page.details.dependencies.parameter')}:
              </Text>
              <Text className="text-base">
                {transformQuestionDependencyParameter(dependency.parameters[0])}
              </Text>
            </div>
          )}

          <div className="flex flex-col">
            <Text className="text-base text-base-600">
              {t('question_page.details.dependencies.source_question')}:
            </Text>
            <Text className="text-base">{dependency?.text}</Text>
          </div>
        </AntdSpace>
        {!IS_REVIEWER && (
          <AntdSpace className="justify-center w-full">
            <Button
              type="text"
              icon={<FormOutlined />}
              className="text-primary-600"
              onClick={onEditClick}
            >
              {t('patient:common.edit')}
            </Button>

            <Link
              className="text-primary-600"
              target="_blank"
              to={`/${paths.app}/${paths.questions_library.root}/${dependency?.sourceId}/${paths.questions_library.details}`}
            >
              <ArrowUpRightIcon />
              {t('patient:common.open_in_new_tab')}
            </Link>
          </AntdSpace>
        )}
      </AntdSpace>

      <div className="w-[1px] h-6 bg-base-600" />

      <div className="p-4 bg-base-100 rounded-default border-solid border-primary-600">
        <Text className="text-xl font-medium">{questionText}</Text>
      </div>
    </AntdSpace>
  );
};
